import * as React from 'react';

import './mobile-navigationbar.scss';
import { Drawer } from 'antd';
import { RootState } from 'core/redux/store';
import { connect, ConnectedProps } from 'react-redux';
import { setSidebar } from 'core/redux/actions';
import { MobileItems } from 'core/domain/commons/menu';
import MobileNavigationBarItem from './navbar-item/navbar-item';
import { getWaitingCounts } from 'core/repositories/transaction';
import { WaitingItemCount } from 'core/domain/transaction/transaction';
import { ReactComponent as Logout } from 'assets/icons/dash-line-icons/logout.svg';
import { useDispatch } from 'react-redux';
import { Modal } from 'components/modal/modal';
import { Button, buttonType } from 'components/button/button';
import { useNavigate } from 'react-router-dom';

const mapState = (state: RootState) => ({
    state: state,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {}

const MobileNavigationbar: React.FC<Props> = ({ state }) => {
    const [modalIsOpen, setModalIsOpen] = React.useState<boolean>(false);
    const [waitingCounts, setWaitingCounts] = React.useState<WaitingItemCount>();

    // همان شمارنده‌هایی که سایدبار دسکتاپ نشان می‌دهد.
    React.useEffect(() => {
        getWaitingCounts(setWaitingCounts);
    }, []);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const onLogoutClick = () => {
        setModalIsOpen(true);
    };
    return (
        <Drawer
            className="navigation-drawer"
            open={state.sidebar === 'close' ? false : true}
            onClose={() => dispatch(setSidebar('close'))}
            placement="bottom"
            headerStyle={{ display: 'none' }}
        >
            <Modal setIsOpen={setModalIsOpen} isOpen={modalIsOpen} className="logout-modal">
                <p>آیا از خارج شدن از حسابتان اطمینان دارید؟</p>

                <div className="buttons">
                    <Button type={buttonType.info} text="بله" onClick={() => window.open('/signin', '_self')} />
                    <Button type={buttonType.error} text="خیر" onClick={() => setModalIsOpen(false)} />
                </div>
            </Modal>
            <>
                <span className="holder"></span>
                {MobileItems.filter((item) => item.title != 'خرید و فروش' && item.title != 'تاریخچه سفارشات').map(
                    (item) => (
                        <MobileNavigationBarItem
                            key={item.id}
                            id={item.id}
                            icon={item.icon}
                            title={item.title}
                            link={item.link}
                            isActive={item.isActive}
                            childrens={item.childrens}
                            waitingCounts={waitingCounts}
                        />
                    ),
                )}
                <a
                    onClick={() => {
                        onLogoutClick();
                    }}
                    className={`mobile-navigationbar-item logout red`}
                >
                    <div className="content">
                        <Logout />
                        <p className="title">خروج</p>
                    </div>
                </a>
            </>
        </Drawer>
    );
};

export default connector(MobileNavigationbar);
